import translateGeneral from '@/services/validation/translator';
import { erreurStringLength, STRING_LENGTH } from '@/services/validation/erreurStringLength';
import { erreurReferenceHavas, API_SPOT_HAVAS_ERROR_REFERENCE } from '@/services/validation/erreurReferenceHavas';

export default function validation(i18n, response, messages, translate) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    if (response.data && response.data.error && response.data.error.message === 'Exception of type \'Abp.Domain.Entities.EntityNotFoundException\' was thrown.') {
      messages.push({ message: 'validation.notAccess' });
    }
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    let champs = 0;
    if (error.members) {
      champs = error.members[0];
      if (translate) champs = translate(i18n, champs);
      champs = translateGeneral(i18n, champs);
    }
    const message = error.message;
    if (message.indexOf(STRING_LENGTH) !== -1 && champs) {
      erreurStringLength(message, champs, messages);
    }
    if (message.indexOf(API_SPOT_HAVAS_ERROR_REFERENCE) === 0) {
      erreurReferenceHavas(message, messages);
    }
  });
}
